import { tokenStorage } from '../services/api';

/**
 * User data stored in localStorage (if any)
 * This is a fallback - primary auth state is in React context
 */
interface StoredUser {
  role?: string;
  id?: number;
  email?: string;
}

/**
 * Get user data from localStorage if available
 * This is used for synchronous auth checks in route loaders
 * @returns User object with role, or null if not found
 */
export function getUserFromStorage(): StoredUser | null {
  try {
    const userStr = localStorage.getItem('user');
    if (!userStr) {
      return null;
    }
    const user = JSON.parse(userStr) as unknown;
    
    // Type guard to ensure it's a valid user object
    if (user && typeof user === 'object' && 'role' in user) {
      return user as StoredUser;
    }
    return null;
  } catch {
    return null;
  }
}

/**
 * Check if user is authenticated (has valid token)
 * @returns true if access token exists, false otherwise
 */
export function checkAuth(): boolean {
  const token = tokenStorage.getAccessToken();
  return token !== null && token !== '';
}

/**
 * Check if user has admin role
 * @returns true if user is authenticated and has admin role
 */
export function checkAdminRole(): boolean {
  if (!checkAuth()) {
    return false;
  }
  
  const user = getUserFromStorage();
  return user?.role === 'admin';
}

/**
 * Check if user has agency role
 * @returns true if user is authenticated and has agency role
 */
export function checkAgencyRole(): boolean {
  if (!checkAuth()) {
    return false;
  }
  
  const user = getUserFromStorage();
  return user?.role === 'agency';
}

